import {
  CALL_RESET,
  CALL_SET,
  CALL_SET_CONSULT,
  LOGOUT,
  UPDATE_CALL,
  UPDATE_CALL_TRANSFER_ENDPOINTS,
  RESET_NORMAL_CALL,
  STORE_LOGIN,
  RESET_STATE,
  HISTORY_FILTER_CALL_COUNT,
  DIAL_CALL_IN_PROGRESS,
} from "../constants/action-types";
import { Call } from "../types/call.type";

const initialState: Call = {
  id: "",
  customer: null,
  self: null,
  queue: undefined,
  remaining: undefined,
  allowedTransferEndpoints: [],
  callCount: 0,
  dialCallInProgress: false,
  beingBarged: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case CALL_SET:
      if (action.call?.id) {
        return {
          ...state,
          ...action.call,
        };
      }
      return {
        ...initialState,
      };

    case CALL_SET_CONSULT:
      return {
        ...state,
        consultCall: action.consultCall,
      };
    case LOGOUT:
    case CALL_RESET:
      return {
        ...initialState,
      };
    case UPDATE_CALL:
      const connectedTime = new Date(
        action.call.self?.connectedTime || ""
      ).getTime();

      const endTime = action.call.self?.endTime
        ? new Date(action.call.self?.endTime).getTime()
        : 0;
      return {
        ...state,
        ...action.call,
        self: {
          ...action.call.self,
          connectedTime,
          endTime,
        },
      };
    case UPDATE_CALL_TRANSFER_ENDPOINTS:
      return {
        ...state,
        allowedTransferEndpoints: action.call,
      };
    case RESET_NORMAL_CALL:
      return {
        ...initialState,
      };
    case STORE_LOGIN:
      return {
        ...state,
        ...action.payload?.call,
      };
    case DIAL_CALL_IN_PROGRESS:
      return {
        ...state,
        dialCallInProgress: action.dialCallInProgress,
      };
    case RESET_STATE:
      return {};
    case HISTORY_FILTER_CALL_COUNT:
      return {
        ...state,
        callCount: action.callCount,
      };
    default:
      return state;
  }
};
